<div class="wrapper">
    <svg-icon
        *ngIf="!innerControl.value?.length"
        src="assets/images/header-search.svg"
        [svgClass]="'icon-search'"></svg-icon>
    <svg-icon
        *ngIf="innerControl.value?.length"
        (click)="resetSearch()"
        src="assets/images/icon-menu-close.svg"
        [svgClass]="'icon-close'"></svg-icon>
    <input
        #searchInput
        [formControl]="innerControl"
        placeholder="Search..."
        type="text" />
</div>
